
export const getRegisteringAccount = state => state.loading || false;



// WEBPACK FOOTER //
// ./src/redux/registerAccount/selectors.js